import React from 'react';
import './about.css'
import AboutContainer from './AboutContainer'
import TimelineContainer from '../Timeline/TimelineContainer'

const About = () => {
    return (
        <div>
            <AboutContainer />
            <TimelineContainer />
        </div>
    );
}

export default About;
